import { render, staticRenderFns } from "./GalleryList.vue?vue&type=template&id=9bf6fcd0&"
import script from "./GalleryList.vue?vue&type=script&lang=js&"
export * from "./GalleryList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports